import DashboardTargetRecord from './DashboardTargetRecord';
import BackdropModal from 'Shared/components/BackdropModal/BackdropModal';
import { useAct } from 'DashboardUser/store';

export default function RecordModal() {
  const act = useAct();
  const dashboardTargetId = useSel(s => s.local.expandedDashboardTargetId);
  function close() {
    act.local.upsert({ expandedDashboardTargetId: null });
  }
  const name = useSel(s => {
    const dashboardTarget = s.dashboardTargets.entities[dashboardTargetId];
    console.log(s.dashboard.dashboardFields);
    const nameField = s.dashboard.dashboardFields.find(f => f.source === 'column' && f.name === 'Name');

    if (!nameField) return 'Record';

    return dashboardTarget[nameField.id] || 'Record';
  })

  return <BackdropModal open onCancel={close} hideClose>
    <h2>{name}</h2>
    <DashboardTargetRecord dashboardTargetId={dashboardTargetId} />
    <div className="modal-footer">
      <button className="button primary" onClick={close}>
        Done
      </button>
    </div>
  </BackdropModal>
}
